import { useAuthQuery } from "@bn/api";
import { Account } from "@api/v1/model";
import { getAccount } from "@api/v1/methods";
import { ACCOUNT } from "../../cacheKeys";

export const useAccount = (accountId?: number) =>
  useAuthQuery<Account, AxiosApiError, Account>(
    [ACCOUNT, accountId],

    ({ token }) => getAccount(token, accountId!),
    {
      enabled: !!accountId,
    }
  );
